import { Cross } from '@ori-ui/icons';
import React from 'react';
const MuiAutocomplete = {
  closeIcon: /*#__PURE__*/React.createElement(Cross, {
    fontSize: "small"
  })
};
export default MuiAutocomplete;